// extracted by mini-css-extract-plugin
export var date = "CommuniqueCardBlock-module--date--49981";
export var dateMobile = "CommuniqueCardBlock-module--dateMobile--0bb5e";
export var icon = "CommuniqueCardBlock-module--icon--3b346";
export var iconContainer = "CommuniqueCardBlock-module--iconContainer--5c557";
export var img = "CommuniqueCardBlock-module--img--ff982";
export var learnMore = "CommuniqueCardBlock-module--learnMore--3e69c";
export var pressCard = "CommuniqueCardBlock-module--pressCard--c4186";
export var pressCardContainer = "CommuniqueCardBlock-module--pressCardContainer--388f2";
export var pressContent = "CommuniqueCardBlock-module--pressContent--ca188";
export var pressDate = "CommuniqueCardBlock-module--pressDate--26fd0";
export var pressImg = "CommuniqueCardBlock-module--pressImg--f6817";